export enum ERROR_CODES {
  REDEEM_PAY_PRICE = 10001,
  UNIQ_TOKEN_GENERATION = 20001,
}
